<template>
  <div class="home-box home-blog" v-if="isInFrench">
    <div class="container">
      <div class="page">
        <div class="title-room">
          <h2 class="titlesection">{{ $t('home.titles.blog').toUpperCase() }}</h2>
          <h3 class="titlesection">{{ $t('home.titles.blogDescription') }}</h3>
        </div>
<!--        <ul class="blog-card">-->
<!--          <li v-for="(item, index) in [1,2, 3]" :key="item" :index="index" v-if="loading">-->
<!--            <div class="ph-item">-->
<!--              <div class="ph-picture"></div>-->
<!--              <div class="ph-col-12">-->
<!--                <div class="ph-row">-->
<!--                  <div class="ph-col-10 big"></div>-->
<!--                </div>-->
<!--                <div class="ph-row"></div>-->
<!--                <div class="ph-row"></div>-->
<!--                <div class="ph-row">-->
<!--                  <div class="ph-col-12"></div>-->
<!--                  <div class="ph-col-10"></div>-->
<!--                  <div class="ph-col-11"></div>-->
<!--                  <div class="ph-col-8"></div>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </li>-->
<!--          <li v-for="(article, index) in articles" :key="article.title" :index="index" :item="article" v-if="!loading">-->
<!--            <a :href="article.link" target="_blank" class="room-card">-->
<!--              <div class="image&#45;&#45;wrapper-blog">-->
<!--                <div class="as-image" :style="`background-image: url(${article.picture})`"></div>-->
<!--              </div>-->
<!--              <h4 class="blog-content">{{ article.title }}</h4>-->
<!--              <p class="blog-content">{{ article.description | noHtml | strlen(150) }}</p>-->
<!--              <div class="room-footer">-->
<!--                <div class="card-button">{{ $t('blog.readMore') }}</div>-->
<!--              </div>-->
<!--            </a>-->
<!--          </li>-->
<!--        </ul>-->
        <div class="room-discover">
          <a :href="`https://blog.mihotel.fr/${blogLang}`" target="_blank" class="colored-btn blue-btn">
            <span>{{ $t('blog.gotoBlog') }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'home-blog',
  async created() {
    await this.$store.dispatch('blog/fetch');
  },
  computed: {
    ...mapState({
      // loading: state => state.blog.loading,
      // articles: state => state.blog.articles,
      lang: s => (s.lang.currentLang || 'fr').toLowerCase(),
      blogLang: s => {
        const lang = (s.lang.currentLang || 'fr').toLowerCase();
        if (lang === 'fr') return '';
        return lang;
      }
    }),
    isInFrench () {
      return (this.lang).toLowerCase() === 'fr';
    }
  },
};
</script>

<style scoped>
/*.ph-item {
  border: none;
  margin: 0;
  padding: 0;
}
.ph-item .ph-picture {
  height: 220px;
}
.page ul {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr;
}
@media (max-width: 1200px) {
  .page ul {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .page ul {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 1fr;
  }
}

.page ul li {
  display: block;
  float: none;
  width: 100%;
  margin: 0;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
}
.page ul li .image--wrapper {
  height: 220px;
  width: 100%;
  position: relative;
  display: block;
  float: none;
}
.page ul li img {
  position: absolute;
  height: 220px;
  top: 0;
  left: 0;
}*/
</style>



// WEBPACK FOOTER //
// src/pages/home/home-blog.vue